import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=b0a88bac&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0a88bac')) {
      api.createRecord('b0a88bac', component.options)
    } else {
      api.reload('b0a88bac', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=b0a88bac&", function () {
      api.rerender('b0a88bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/recaps/Index.vue"
export default component.exports